import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import CopyRight from "src/Components/Custom/CopyRight/CopyRight";
import Footer from "src/Components/Custom/Footer/Footer";
import NavBar from "src/Components/Custom/NavBar/NavBar";
import PrivacyContentAr from "./PrivacyContentAr";
import PrivacyContentEn from "./PrivacyContentEn";
import PrivacyContentFr from "./PrivacyContentFr";

function PrivacyPage() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <Fragment>
      <header>
        <NavBar />
      </header>
      {lang ==='ar'?<PrivacyContentAr/>:
      lang === 'fr' ? <PrivacyContentFr /> : <PrivacyContentEn />}
      <Footer />
      <CopyRight />
    </Fragment>
  );
}

export default PrivacyPage;
